import { render, staticRenderFns } from "./SubmissionFormSubmissionType.vue?vue&type=template&id=1b4fde49&scoped=true&"
import script from "./SubmissionFormSubmissionType.vue?vue&type=script&lang=js&"
export * from "./SubmissionFormSubmissionType.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionFormSubmissionType.vue?vue&type=style&index=0&id=1b4fde49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4fde49",
  null
  
)

export default component.exports